import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/service/storage.service';
import { MobileMenuService } from 'src/app/service/mobile-menu.service';

@Component({
  selector: 'app-bannerregistrados',
  templateUrl: './bannerregistrados.component.html',
  styleUrls: ['./bannerregistrados.component.css']
})
export class BannerregistradosComponent {
  seleccionado: boolean = false;
  esAdministrado: boolean = false;


  constructor(
    private storageService: StorageService,
    private route: Router,
    public mobileMenu: MobileMenuService){

  }

  ngOnInit(): void {
    this.esAdministrado = this.storageService.esAdministrador();

  }


  salir(){
    this.storageService.removeUsuarioStorage();
    this.route.navigate(['/login/ingresar']);
  }
}
